import React, { useEffect, useState } from "react";
import { IoMdNotificationsOff } from "react-icons/io";
import {
  Badge,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Box,
  Text,
  Stack,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";
import { BellIcon } from "@chakra-ui/icons";
import { useCookies } from "react-cookie";
import config from "../../config";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function AlertNotification({navbarIcon}) {
  const [cookie] = useCookies(["token"]);
  const [notifications, setNotifications] = useState([]);
  const markedRead =async()=>{
   
              const ids = notifications.map((n) => n._id);
              try {
                await fetch(`${config.apiUrl}/markAsRead`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${cookie.token}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ ids }),
                });
                setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
              } catch (error) {
                console.error("Error marking notifications as read:", error);
              }
            
  }
  // Fetch the 10 latest notifications on component mount
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await fetch(`${config.apiUrl}/notifications`, {
          headers: {
            Authorization: `Bearer ${cookie.token}`,
          },
        });
        const data = await res.json();
        setNotifications(data || []);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, [cookie.token]);

  // SSE: Receive real-time notifications
  useEffect(() => {
    const eventSource = new EventSource(
      `${config.apiUrl}/notifications/stream?access_token=${cookie.token}`
    );

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setNotifications((prev) => [data, ...prev.slice(0, 9)]); // Keep max 10
    };

    return () => {
      eventSource.close();
    };
  }, [cookie.token]);

  const unreadCount = notifications.filter((n) => !n.isRead).length;
  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Box onClick={markedRead} position="relative">
          <BellIcon
            color={navbarIcon}
            w="25px"
            h="25px"
            cursor="pointer"
            
          />
          {notifications.filter((n) => !n.isRead).length != 0 && (
            <div
              class="badge badge-light"
              style={{
                color: "black",
                height: "14px",
                width: "14px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                position: "absolute",
                top: "5px",
                left: "10px",
              }}
            >
              <span>{notifications.filter((n) => !n.isRead).length}</span>
            </div>
          )}
        </Box>
      </PopoverTrigger>
      <PopoverContent w="350px" maxH="400px" overflowY="auto">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader color="gray.800" fontWeight="bold">
          Notifications
        </PopoverHeader>
        <PopoverBody>
          {notifications.length == 0 ? (
            <Box display="flex" alignItems="center">
              <IoMdNotificationsOff
                style={{ color: "black", fontSize: "22px" }}
              />
              <Text>No Notification Found</Text>
            </Box>
          ) : (
            <Stack spacing={4}>
              {notifications.map((notif, idx) => (
                <Box
                  key={idx}
                  p={3}
                  borderWidth="1px"
                  borderRadius="md"
                  bg={notif.isRead ? "gray.100" : "blue.100"}
                >
                  <Flex justify="space-between">
                    <Text
                      fontSize="sm"
                      color={"gray.800"}
                      fontWeight="semibold"
                    >
                      {notif.type.replace("-", " ").toUpperCase()}
                    </Text>
                    <Text fontSize="xs" color="gray.500">
                      {new Date(notif.createdAt).toLocaleString()}
                    </Text>
                  </Flex>
                  <Text textAlign={'left'} color={'grey'}>by {notif?.LinkId?.submittedBy}</Text>
                  <Flex justify="space-between">
                    <Text
                      style={{
                        textWrap: "auto",
                        textAlign: "left",
                      }}
                      color="gray.800"
                      fontSize="sm"
                      mt={1}
                    >
                      {notif?.type == "follow - up" || notif.type=="New Candidate" && notif.message}
                      {notif?.type == "New Job" &&
                        "The new job has been created"}
                      {notif?.type == "New Submission" &&
                        "The new submission has been created in the "}
                      {notif?.LinkId?.jobId && (
                        <Link
                          style={{ color: "#083c64" }}
                          to={
                            `/details/jobpostview/${notif?.LinkId?.jobId}`
                          }
                          target="_blank"
                        >
                          {" "}
                          {notif?.LinkId?.jobName}
                        </Link>
                      )}
                      {notif?.LinkId?.candidateId && " for the"}
                      {notif?.LinkId?.candidateId && (
                        <Link
                          style={{ color: "#083c64" }}
                          to={
                            `/details/candidateview/${notif?.LinkId?.candidateId}`
                            // moduleData.view == "none" ||
                            // (moduleData?.view == "ownrecords" &&
                            //   value?.job_ownerName?._id !==
                            //     userId)
                            //   ? "/admin/jobpost"
                            //   : `/details/jobpostview/${value._id}`
                          }
                          target="_blank"
                        >
                          {" "}
                          {notif?.LinkId?.candidateName}
                        </Link>
                      )}
                    </Text>
                  </Flex>
                </Box>
              ))}
            </Stack>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default AlertNotification;
